import { NavLink } from 'react-router';
import { useSession } from '@/context/session/useSession';

export function Logo() {
  const { session } = useSession();
  return (
    <NavLink to={session ? '/' : '/account/signin'}>
      <img src="/floppydata-logo.svg" />
    </NavLink>
  );
}
